import { Languages } from '@dark-portal/backend-planora';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

function loadTranslations(lang: string): Record<string, any> {
  const context =
    lang === Languages.EN
      ? (require as any).context('../', true, /i18n\/en\.json$/)
      : (require as any).context('../', true, /i18n\/pl\.json$/);

  return context.keys().reduce((acc: Record<string, any>, key: string) => {
    return deepMerge(acc, context(key));
  }, {});
}

function deepMerge(target: any, source: any): any {
  const result = { ...target };
  Object.keys(source).forEach((key) => {
    result[key] =
      typeof result[key] === 'object' && typeof source[key] === 'object'
        ? deepMerge(result[key], source[key])
        : source[key];
  });
  return result;
}

export const resources = {
  [Languages.EN]: { global: loadTranslations(Languages.EN) },
  [Languages.PL]: { global: loadTranslations(Languages.PL) },
};

export const defaultNS = 'global';

function detectLanguage(): string {
  const browserLang = (navigator.language?.split('-')[0] ?? Languages.EN) as Languages;

  return Object.values(Languages).includes(browserLang) ? browserLang : Languages.EN;
}

i18n.use(initReactI18next).init({
  ns: ['global'],
  defaultNS,
  resources,
  lng: detectLanguage(),
  fallbackLng: Languages.EN,
  returnNull: false,
  interpolation: { escapeValue: false },
});

export default i18n;
